/**
 * Extend the Window interface to include the `gtag` property.
 * @typedef {typeof globalThis & { gtag?: (...args: any[]) => void }} CustomWindow
 */

/**
 * Get the Google Analytics Client ID (GACID).
 * @returns {string | undefined} The GACID if available, `null` if not found, or `undefined` if not applicable.
 */
export function getGACID() {
  const win = /** @type {CustomWindow} */ (window)

  if (typeof window === 'undefined' || typeof win.gtag !== 'function') {
    return undefined
  }

  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_ga='))
    ?.split('=')[1]

  if (!cookieValue) {
    return undefined
  }

  const cid = cookieValue.split('.').slice(2).join('.')
  return cid
}
